import React, { useState } from "react";
import { useHistory } from "react-router-dom";

// styles
import "../../../static/styles/components/selfServePerk.css";

// components
import CompanyInformation from "./companyInformation";
import RedemptionInformation from "./redemptionInformation";
import PerkInformation from "./perkInformation";
import PerkStepBar from "./stepBar";
import { usePageTitle } from "hooks/usePageTitle";
import { PerkCards } from "../PerkCards";
import { Button } from "components/DesignSystem/Button/Button";

const PerkStepController = () => {
  usePageTitle("Perks");
  const history = useHistory();
  const [currentState, setCurrentState] = useState(0);
  const [perkData, setPerkData] = useState({});
  const [previewImage, setPreviewImage] = useState();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPerkData({ ...perkData, [name]: value });
  };

  const goBack = () => history.push("/community/perks");
  const recreate = () => window.location.reload();

  const showForm = () => {
    switch (currentState) {
      case 0: {
        return (
          <CompanyInformation
            setPerkData={setPerkData}
            goBack={goBack}
            setPreviewImage={setPreviewImage}
            handleChange={handleChange}
            setCurrentState={setCurrentState}
            perkData={perkData}
          />
        );
      }
      case 1: {
        return (
          <PerkInformation
            setPerkData={setPerkData}
            goBack={goBack}
            handleChange={handleChange}
            setCurrentState={setCurrentState}
            perkData={perkData}
          />
        );
      }
      case 2: {
        return (
          <RedemptionInformation
            setPerkData={setPerkData}
            goBack={goBack}
            handleChange={handleChange}
            setCurrentState={setCurrentState}
            perkData={perkData}
          />
        );
      }
      default:
        return <></>;
    }
  };
  return (
    <div className="selfServePerkContainer t-w-4/5 t-mx-auto">
      <PerkStepBar currentState={currentState} />
      {currentState !== 3 ? (
        <div className="perkStateContainer">
          <div className="leftContainer perksBodyContainer t-p-5">
            <PerkCards
              perk={{ ...perkData, icon: previewImage }}
              isPreview={true}
            />
          </div>
          <div className="rightContainer">{showForm()}</div>
        </div>
      ) : (
        <div className="perkStateContainer perksBodyContainer t-p-5">
          <div className="successFulContainer">
            <PerkCards
              perk={{ ...perkData, icon: previewImage }}
              isPreview={true}
            />
            <span className="heading">Thank you for submitting your perk!</span>
            <span className="content">
              Your perk is being reviewed by our team. We will notify you once
              we’re done.{" "}
            </span>
            <div className="d-flex justify-content-between">
              <Button customType="primary" onClick={goBack}>
                Go Back
              </Button>
              <Button customType="primary" onClick={recreate}>
                Add another perk
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PerkStepController;
